// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"c6de65cd","321":"31b9094d","453":"70e2c079"}[chunkId] + ".chunk.js";
};